import VueBusiness from "@/business/VueBusiness";
import AtoBusiness from "@/business/protocolo/AtoBusiness";
import ProtocoloBusiness from "@/business/protocolo/ProtocoloBusiness";
import ProtocoloCustaAdicionalBusiness from "@/business/protocolo/ProtocoloCustaAdicionalBusiness";
import FrontBusiness from "@/business/FrontBusiness";
import Utils from "@/commons/Utils";

export default {
  /**
   * Validação das consultas BIB dos envolvidos, espelhando o validarEnvolvidosAto do
   * RegrasEstaduaisRJBusiness: com a lista consultasBib preenchida vale a lista (uma consulta
   * por item); sem lista, valem os campos legados. Consulta vencida é aviso, não bloqueio.
   */
  validarBibEnvolvidos(ato, criarErro) {
    const consultasDoEnvolvido = e => Array.isArray(e.consultasBib) ? e.consultasBib : [];

    const semBib = e => {
      const consultas = consultasDoEnvolvido(e);
      if (consultas.length) {
        return consultas.every(c => Utils.isEmptyNullOrUndefined(c?.numero));
      }
      return Utils.isEmptyNullOrUndefined(e.consultaBib);
    };

    if (ato.tipoServico?.opcoes?.envolvidosSemHashBIB == false && ato.envolvidos?.find(semBib)) {
      criarErro("Necessário informar hash da consulta BIB das partes envolvidas", 'envolvidos', 'erro');
    }

    const validarConsulta = (e, numero, data, gratuito, lei11441) => {
      if (Utils.isEmptyNullOrUndefined(numero)) return;
      if (Utils.isEmptyNullOrUndefined(data)) {
        criarErro("Necessário informar a data da consulta BIB de " + e.nome, 'envolvidos', 'erro');
      }
      if (gratuito == null || gratuito == undefined) {
        criarErro("Necessário informar se a consulta BIB de " + e.nome + " é gratuita", 'envolvidos', 'erro');
      }
    };

    ato.envolvidos?.forEach(e => {
      const consultas = consultasDoEnvolvido(e);
      if (consultas.length) {
        consultas.forEach(c => validarConsulta(e, c?.numero, c?.data, c?.gratuito, c?.lei11441));
      } else {
        validarConsulta(e, e.consultaBib, e.dataConsultaBib, e.gratuitoBib, e.lei11441Bib);
      }
    });
  },

  async tratarPrenotacao({protocoloId, ato}) {
    ato.prenotacao = { exibir: 'não', emolumentos: 0, emolumentosBrutos: 0, fundos: {}, total: 0, iss: 0, custoSelo: 0, taxaJudiciaria: 0, fundosEstaduais: 0 };
    ato.busca = { exibir: 'não', emolumentos: 0, emolumentosBrutos: 0, fundos: {}, total: 0, iss: 0, custoSelo: 0, taxaJudiciaria: 0, fundosEstaduais: 0 };
    if (!VueBusiness.getVueRoot().isEstadoGO || !protocoloId) return ato;
    let primeiroAto = await AtoBusiness.getPrimeiroAtoComValor(protocoloId);
    if (primeiroAto !== ato.id) return ato;

    let prenotacoes = await ProtocoloBusiness.listarPrenotacao(protocoloId);
    for (const prenotacao of prenotacoes) {
      let custas = prenotacao?.custas;
      if (custas && typeof custas === "string") custas = JSON.parse(custas);
      ato.prenotacao.exibir = 'sim';
      ato.prenotacao = FrontBusiness.somarTaxas(custas, ato.prenotacao, 1)
    }
    let custasAdicionais = await ProtocoloCustaAdicionalBusiness.listar(protocoloId);
    for (const custaAdicional of custasAdicionais) {
      if (!['PAGAMENTO_DIFERIDO_CNIB_BUSCA', 'BUSCA'].includes(custaAdicional?.tipoServico?.regraCustas)) continue;
      let custas = custaAdicional?.custas;
      if (custas && typeof custas === "string") custas = JSON.parse(custas);
      ato.busca.exibir = 'sim';
      ato.busca = FrontBusiness.somarTaxas(custas, ato.busca, custaAdicional.quantidade)
    }

    return ato;
  },
}
